import { ThemeProvider, createTheme } from "@mui/material/styles";

import type { Game } from "src/api";

import "./App.css";
import { AppRoutes } from "./Routes";
import { GameProvider } from "./game/GameContext";

const theme = createTheme({ cssVariables: true, palette: { mode: "dark" } });

export default function AppByHumans({ game }: { game: Game }) {
  return (
    <ThemeProvider theme={theme}>
      <GameProvider game={game}>
        <div className="app">
          <AppRoutes />
        </div>
      </GameProvider>
    </ThemeProvider>
  );
}
